export default {
  "pl": {
    "issue_category": {
      "labels": {
        "category_name": "Nazwa kategorii",
        "new_category": "Nowa kategoria wydania"
      }
    }
  }
}
